import script from "./MGraficoAtividadesPorPeriodo.vue?vue&type=script&lang=ts&setup=true"
export * from "./MGraficoAtividadesPorPeriodo.vue?vue&type=script&lang=ts&setup=true"

import "./MGraficoAtividadesPorPeriodo.vue?vue&type=style&index=0&id=dc92b652&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc92b652"]])

export default __exports__